<template>
  <LayoutDetail class="view-dashboard-data">
    <div class="view-dashboard-data-header">
      <h1>Mes paramètres</h1>
    </div>
    <InputSelect
      id="unit-selector"
      border
      :options="getUnitOptions()"
      v-model="selected_unit"
      class="selector"
    />
    <CompositeSiteParameters
      v-if="store_organization_unit.getRoot?.childrens && selected_unit !== undefined"
      :node="store_organization_unit.getRoot?.childrens[selected_unit]"
    />
  </LayoutDetail>
</template>

<script setup lang="ts">
import LayoutDetail from '@/components/layout/LayoutDetail.vue'

import CompositeSiteParameters from '@/components/composite/CompositeSiteParameters.vue'
import InputSelect from '@/components/common/input/InputSelect.vue'
import { onMounted, ref } from 'vue'
import type { SopremaInputSelectOption } from '@/components/common/input/InputSelect.vue'
import { useOrganizationUnitStore } from '@/stores/store_organization_unit'

const selected_unit = ref(undefined)
const store_organization_unit = useOrganizationUnitStore()

function getUnitOptions(): SopremaInputSelectOption[] {
  if (!store_organization_unit.getRoot?.childrens) {
    return []
  }

  let options: SopremaInputSelectOption[] = store_organization_unit.getRoot.childrens.map(
    (unit, index) => {
      return { label: unit.name, value: index.toString() }
    }
  )

  return options
}
</script>

<style scoped>
.view-dashboard-data-header {
  margin-bottom: var(--spacer);
}

.selector {
  margin-bottom: var(--spacer);
}
</style>
